module.exports = __webpack_public_path__ + "img/martha-coffin-wright.1cf62c38.png";